import { Route, Routes } from 'react-router-dom';

import DataProtection from '../components/DataProtection';
import DataProtectionLayout from '../components/DataProtectionLayout';
import DataProtectionPendingDeleteRequest from '../components/DataProtectionPendingDeleteRequest';

export const DataProtectionRoutes = () => {
  return (
    <Routes>
      <Route path="/email/:companyName/:companyId" element={<DataProtection />} />
      <Route path="/:companyName/:companyId/*" element={<DataProtectionLayout />} />
      <Route
        path="/:companyName/:companyId/pending_delete_request"
        element={<DataProtectionPendingDeleteRequest />}
      />
    </Routes>
  );
};
